import { Dispatch, SetStateAction, useEffect, useState } from "react"
import {
    CreateOfficeSpecification,
    FindOfficeByNameResponsePayload,
    FindOfficeByNameSpecification
} from "pokal_api"
import { ArrayElement } from "../types/ArrayElement"
import TextField from "./TextField"
import MoveContentToRight from "./MoveContentToRight"
import Button from "./Button"
import TableHeader from "./TableHeader"

interface SelectOfficeComponentProps {
    onBack: () => void
    onSignUp: () => void
    selection: string | null
    setSelection: Dispatch<SetStateAction<string | null>>
}

function SelectOfficeComponent(props: SelectOfficeComponentProps) {
    const [offices, setOffices] = useState<FindOfficeByNameResponsePayload>([])

    const nameState = useState<string>("")
    const addressLine1State = useState<string>("")
    const addressLine2State = useState<string>("")
    const postalCodeState = useState<string>("")
    const cityState = useState<string>("")

    const headers = [
        "Name",
        "Addresse (Zeile 1)",
        "Addresse (Zeile 2)",
        "Postleitzahl",
        "Stadt"
    ]

    function fetchOffices() {
        FindOfficeByNameSpecification.request({ name: searchInput[0] }).then(
            (offices) => setOffices(offices)
        )
    }

    useEffect(() => {
        fetchOffices()
    }, [])

    function officeToStringArray(
        office: ArrayElement<FindOfficeByNameResponsePayload>
    ): string[] {
        return [
            office.name,
            office.addressLine1,
            office.addressLine2 ?? "",
            office.postalCode,
            office.city
        ]
    }

    function clearValues() {
        nameState[1]("")
        addressLine1State[1]("")
        addressLine2State[1]("")
        postalCodeState[1]("")
        cityState[1]("")
    }

    function onCreateOffice() {
        CreateOfficeSpecification.request({
            name: nameState[0],
            addressLine1: addressLine1State[0],
            addressLine2: addressLine2State[0],
            postalCode: postalCodeState[0],
            city: cityState[0],
            country: "Deutschland"
        }).then(() => {
            fetchOffices()
            clearValues()
        })
    }

    function createOfficeEnabled(): boolean {
        return (
            nameState[0] !== "" &&
            addressLine1State[0] !== "" &&
            postalCodeState[0] !== "" &&
            cityState[0] !== ""
        )
    }

    const searchInput = useState<string>("")

    return (
        <div className={"w-full flex flex-col mb-10"}>
            <div className={"mb-10 mt-5 flex space-x-2"}>
                <TextField
                    placeholder={"Suchbegriff hier eingeben"}
                    type={"text"}
                    inputState={searchInput}
                    width={"100%"}
                />
                <Button onClick={fetchOffices}>Suchen</Button>
            </div>
            <TableHeader
                elements={headers}
                empty={offices.length === 0}
                onEmpty={"Keine Praxen verfügbar."}
            />
            {offices.map((office) => (
                <div
                    key={office.id}
                    onClick={() => {
                        if (props.selection === office.id)
                            props.setSelection(null)
                        else props.setSelection(office.id)
                    }}
                    className={
                        "w-full flex space-x-4 py-4 px-2 cursor-pointer rounded border-2 " +
                        (props.selection && props.selection === office.id
                            ? "border-blue-600 bg-blue-600 bg-opacity-20"
                            : "border-transparent hover:bg-neutral-100 hover:border-neutral-300")
                    }>
                    {officeToStringArray(office).map((cell, index) => (
                        <div
                            className={"flex-1 overflow-x-scroll"}
                            key={office.id + index}>
                            {cell}
                        </div>
                    ))}
                </div>
            ))}
            <div className={"w-full flex space-x-4 px-2 mt-8"}>
                <div className={"flex-1"}>
                    <TextField
                        inputState={nameState}
                        placeholder={"Praxisname hier eingeben"}
                        type={"text"}
                        width={"100%"}
                    />
                </div>
                <div className={"flex-1"}>
                    <TextField
                        inputState={addressLine1State}
                        placeholder={"Addresszeile 1 hier eingeben"}
                        type={"text"}
                        width={"100%"}
                    />
                </div>
                <div className={"flex-1"}>
                    <TextField
                        inputState={addressLine2State}
                        placeholder={"Addresszeile 2 hier eingeben"}
                        type={"text"}
                        width={"100%"}
                    />
                </div>
                <div className={"flex-1"}>
                    <TextField
                        inputState={postalCodeState}
                        placeholder={"Postleitzahl hier eingeben"}
                        type={"text"}
                        width={"100%"}
                    />
                </div>
                <div className={"flex-1"}>
                    <TextField
                        inputState={cityState}
                        placeholder={"Stadt hier eingeben"}
                        type={"text"}
                        width={"100%"}
                    />
                </div>
            </div>
            <div className={"w-full flex p-2"}>
                <MoveContentToRight>
                    <div className={"flex space-x-4 mt-10"}>
                        <Button onClick={props.onBack}>Zurück</Button>
                        <Button
                            disabled={!createOfficeEnabled()}
                            onClick={onCreateOffice}>
                            Praxis hinzufügen
                        </Button>
                        <Button
                            onClick={props.onSignUp}
                            disabled={props.selection === null}>
                            Registrierung abschließen
                        </Button>
                    </div>
                </MoveContentToRight>
            </div>
        </div>
    )
}

export default SelectOfficeComponent
